import React from 'react'

export default class IconsJustifyContentEnd extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color

        return (
            <svg
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                style={this.props.style}
            >
                <path d='M14 1.333V14.667' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
                <rect x='5' y='4.6' width='2.2' height='6.8' rx='0.7' stroke={color} strokeWidth='1.25' fill='none' />
                <rect x='9.4' y='2.6' width='2.2' height='10.8' rx='0.7' stroke={color} strokeWidth='1.25' fill='none' />
            </svg>
        )
    }
}
